module.exports = __webpack_public_path__ + "static/media/Simple.9342b9eb.png";